var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLogIn = function SvgIconLogIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 26.8,
    height: 20,
    fill: "currentColor",
    style: {
      enableBackground: "new 0 0 20 26.8"
    },
    viewBox: "0 0 20 26.8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.8H3.6V10c0-3.5 2.9-6.4 6.4-6.4 2.7 0 4.9 1.6 5.9 4l2.7-2.7C16.8 2 13.7 0 10 0 4.5 0 0 4.5 0 10v16.8h20v-13h-2zM7.5 24.1l1.2-3.5c-.5-.4-.9-1.1-.9-1.8 0-1.2 1-2.3 2.3-2.3s2.3 1 2.3 2.3c0 .7-.4 1.4-.9 1.8l1.2 3.5H7.5z",
    className: "icon-log-in_svg__st0"
  })));
};
export default SvgIconLogIn;